import { useEffect, useState } from "react";

const COUNTDOWN_SECONDS = 8 * 60 * 60 + 40 * 60 + 22;
const SESSION_KEY = "recursos-fitness-launch-expiration";

function getOrCreateExpiration(): number {
  const storedExpiration = window.sessionStorage.getItem(SESSION_KEY);
  const parsedExpiration = storedExpiration ? Number(storedExpiration) : Number.NaN;

  if (Number.isFinite(parsedExpiration)) {
    return parsedExpiration;
  }

  const expiration = Date.now() + COUNTDOWN_SECONDS * 1000;
  window.sessionStorage.setItem(SESSION_KEY, String(expiration));
  return expiration;
}

function getSecondsRemaining(expiration: number): number {
  return Math.max(0, Math.ceil((expiration - Date.now()) / 1000));
}

export function useLaunchCountdown(): number {
  const [secondsRemaining, setSecondsRemaining] = useState(COUNTDOWN_SECONDS);

  useEffect(() => {
    const expiration = getOrCreateExpiration();

    const updateCountdown = () => {
      setSecondsRemaining(getSecondsRemaining(expiration));
    };

    updateCountdown();
    const intervalId = window.setInterval(() => {
      const remaining = getSecondsRemaining(expiration);
      setSecondsRemaining(remaining);

      if (remaining === 0) {
        window.clearInterval(intervalId);
      }
    }, 250);

    return () => window.clearInterval(intervalId);
  }, []);

  return secondsRemaining;
}

export function formatCountdown(totalSeconds: number): string {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return [hours, minutes, seconds]
    .map((value) => String(value).padStart(2, "0"))
    .join(":");
}
